'use client';
import styled, { css } from 'styled-components';
import getMediaQueriesStyling from '../../../features/helpers/get-media-query-styling';
export const getLineClampStyling = (lineClamp) => css `
  -webkit-line-clamp: ${lineClamp};
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  word-break: break-word;
`;
export const FitContentStyling = css `
  width: max-content;
  height: fit-content;
  line-height: 1;
`;
export const EllipsisStyling = css `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
`;
export const getStrikeStyling = (isBold) => css `
position: relative;

&:before {
  position: absolute;
  content: "";
  left: 0;
  top: 45%;
  right: 0;
  border-top: ${isBold ? '2px' : '1px'} solid;
  border-color: inherit;

  -webkit-transform: rotate(-5deg);
  -moz-transform: rotate(-5deg);
  -ms-transform: rotate(-5deg);
  -o-transform: rotate(-5deg);
  transform: rotate(-5deg);
  $
}
`;
export const TextStyling = css `
  margin: 0;
  ${(props) => getMediaQueriesStyling(props)}
`;
export const Highlighting = styled.div `
  position: absolute;
  width: 105%;
  height: 70%;
  position: absolute;
  bottom: 1%;
  left: -4%;
  background-color: ${({ $color }) => $color};
`;
export const HighlightContainer = styled.div `
  position: relative;
  width: fit-content;
  display: inline-block;
`;
export const ParagraphContainer = styled.div `
  ${TextStyling}
`;
export const H1 = styled.h1 `
  ${TextStyling}
`;
export const H2 = styled.h2 `
  ${TextStyling}
`;
export const H3 = styled.h3 `
  ${TextStyling}
`;
export const H4 = styled.h4 `
  ${TextStyling}
`;
export const H5 = styled.h5 `
  ${TextStyling}
`;
export const H6 = styled.h6 `
  ${TextStyling}
`;
